import {modalAlert} from "../modules/modalAlert.js";
import {modalConfirm} from "../modules/modalConfirm.js";

import {APIRequest} from "../modules/APIRequest.js";

(async ()=>{

	var pending_login = false;
	$("#login-form").submit(async function(e){
		if(pending_login) return;
		pending_login = true;
		e.preventDefault();
		const email = $("#login-email-input").val().trim();
		const password = $("#login-password-input").val().trim();
		const remember = $("#remember-me-cb").is(':checked');
		
		$("#login-submit-btn").html(`<i class="fas fa-sync fa-spin"></i> Please wait...`).prop('disabled', true);
		var device_details = await getAppDetails();	
		$("#login-form-error").hide();

		var request = new APIRequest();
		request.set('login', 'email', email);
		request.set('login', 'password', password);
		request.set('login', 'device', JSON.stringify(device_details));
		
		var result = (await request.send()).login;
		if(result.errors.length){
			$("#login-form-error").html('<i class="fas fa-skull-crossbones"></i> '+result.errors.join(" "));
			$("#login-form-error").show();
			pending_login = false;
			$("#login-submit-btn").html(`<i class="fas fa-check-square"></i> Submit`).prop('disabled', false);
			if(result.data.can_resend){
				var resend = await modalConfirm('<div class="alert alert-danger"><p>Your account is not active. Please click the link in the welcome email to activate your account. If you don\'t see the email, check your spam folder, otherwise, we can resend it for you.</p><p><b>Would you like us to resend the confimration email?</b></p></div>', 'Resend Email?', 'Resend Email', 'Close');
				if(resend){
					var request = new APIRequest();
					request.set('resendConfirmationEmail', 'email', email);
					result = (await request.send()).resendConfirmationEmail;
					if(result.errors.length){
						await modalAlert('<div class="alert alert-danger">'+result.errors.join(" ")+'</div>', 'Error');
						return;
					}
					await modalAlert('<div class="alert alert-success">The confirmation email was resent. It may take a few minutes to arrive, if you don\'t see it in the next 6 hours, come back and we\'ll send it again it.</div>', 'Success');
					return;
				}
			}
		}else{
			if(remember) localStorage.setItem('mb-login', JSON.stringify([email, password]));
			location.href = "./dashboard.php";
		}
			
	});

	var login = localStorage.getItem('mb-login');
	if(!login) return;
	login = JSON.parse(login);
	if(!login) return;
	
	pending_login = true;
	
	const email = login[0];
	const password = login[1];
	
	$("#login-submit-btn").html(`<i class="fas fa-sync fa-spin"></i> Please wait...`).prop('disabled', true);
	
	var device_details = await getAppDetails();	
	
	var request = new APIRequest();
	request.set('login', 'email', email);
	request.set('login', 'password', password);
	request.set('login', 'from_ls', 1);
	request.set('login', 'device', JSON.stringify(device_details));
	
	var result = (await request.send()).login;
	if(result.errors.length){
		localStorage.removeItem('mb-login');
		pending_login = false;
		$("#login-submit-btn").html(`<i class="fas fa-check-square"></i> Submit`).prop('disabled', false);
	}else{
		location.href = "./dashboard.php";
	}
	
	function getAppDetails(){
		return new Promise(done=>{
			var parser = new UAParser();
			var result = parser.getResult();
			var details = {};
			details.cordova = '';
			details.model = result?.device?.model || '';
			details.platform = result?.os?.name || '';
			details.os_version = result?.os?.version || '';
			details.app_version = '';
			details.browser = result?.browser?.name || '';
			details.browser_version = result?.browser?.version || '';
			done(details);
		});
	}

})();

